import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { Collapse, Column, Grid, GridItem, Row, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import DiscountInput from '~/components/ServiceBuilder/DiscountInput';
import MinPriceTextField from '~/components/ServiceBuilder/MinPriceTextField';
import PriceTextField from '~/components/ServiceBuilder/PriceTextField';
import PricingTextField from '~/components/ServiceBuilder/PricingTextField/PricingTextField';
import { getPriceAfterDiscount, serviceBuilderTextsPath } from '~/components/ServiceBuilder/ServiceBuilder.utils';
import UnitNameTextField from '~/components/ServiceBuilder/UnitNameTextField';
import { useLocaleKeys } from '~/i18n';
import styles from './ServicePriceEditorPopoverPricingContent.module.scss';
export const getServicePriceEditorPopoverPricingContentTID = ()=>getTestIds();
const ServicePriceEditorPopoverPricingContent = (param)=>{
    let { serviceOrigin } = param;
    const { ServicePriceEditorPopoverPricingContentTID } = useMemo(()=>getServicePriceEditorPopoverPricingContentTID(), []);
    const { t: sbTexts } = useLocaleKeys(serviceBuilderTextsPath);
    const { formState } = useFormContext();
    const { pricing, price, minPrice, discount, bundle: includedServices } = useWatch();
    const isBundle = Array.isArray(includedServices);
    const hasDiscountError = Boolean(formState.errors.discount);
    const discountedPrice = useMemo(()=>getPriceAfterDiscount({
            pricing,
            price,
            minPrice,
            discount,
            texts: sbTexts
        }), [
        pricing,
        price,
        minPrice,
        discount
    ]);
    return /*#__PURE__*/ _jsxs(Column, {
        testId: ServicePriceEditorPopoverPricingContentTID.Root(),
        children: [
            /*#__PURE__*/ _jsxs(Grid, {
                rowGap: 24,
                children: [
                    /*#__PURE__*/ _jsx(GridItem, {
                        span: 12,
                        children: /*#__PURE__*/ _jsx(PricingTextField, {
                            isBundle: isBundle,
                            testId: ServicePriceEditorPopoverPricingContentTID.PricingSelect(),
                            serviceOrigin: serviceOrigin,
                            isExistingService: true
                        })
                    }),
                    pricing === 'unit' && /*#__PURE__*/ _jsx(GridItem, {
                        span: 6,
                        children: /*#__PURE__*/ _jsx(UnitNameTextField, {
                            testId: ServicePriceEditorPopoverPricingContentTID.UnitNameTextField()
                        })
                    }),
                    pricing === 'range' && /*#__PURE__*/ _jsx(GridItem, {
                        span: 6,
                        children: /*#__PURE__*/ _jsx(MinPriceTextField, {
                            testId: ServicePriceEditorPopoverPricingContentTID.MinPriceTextField()
                        })
                    }),
                    /*#__PURE__*/ _jsx(GridItem, {
                        span: 6,
                        children: /*#__PURE__*/ _jsx(PriceTextField, {
                            testId: ServicePriceEditorPopoverPricingContentTID.PriceTextField(),
                            disabled: isBundle
                        })
                    }),
                    /*#__PURE__*/ _jsx(GridItem, {
                        span: 6,
                        children: /*#__PURE__*/ _jsx(DiscountInput, {
                            testId: ServicePriceEditorPopoverPricingContentTID.DiscountInput()
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Collapse, {
                in: Boolean(discountedPrice) && !hasDiscountError,
                unmountOnExit: true,
                children: /*#__PURE__*/ _jsx(Row, {
                    className: styles.priceAfterDiscount,
                    testId: ServicePriceEditorPopoverPricingContentTID.PriceAfterDiscount(),
                    children: /*#__PURE__*/ _jsxs(Typography, {
                        as: "span",
                        children: [
                            "Price after discount:",
                            ' ',
                            /*#__PURE__*/ _jsx(Typography, {
                                weight: "normal",
                                as: "span",
                                children: discountedPrice
                            })
                        ]
                    })
                })
            })
        ]
    });
};
export default ServicePriceEditorPopoverPricingContent;
